import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "info-slider" }
const _hoisted_2 = { class: "slider-navigation d-flex justify-content-center" }
const _hoisted_3 = { class: "slider-container" }
const _hoisted_4 = { class: "result-test d-flex justify-content-center align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "info-result" }
const _hoisted_7 = { class: "image-result-container d-flex justify-content-end align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "title"
}
const _hoisted_10 = {
  key: 1,
  class: "title"
}
const _hoisted_11 = { class: "subtitle" }
const _hoisted_12 = {
  key: 2,
  class: "spotify-embed"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "netflix-embed"
}
const _hoisted_15 = { class: "netflix-row" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "netflix-label" }, " Filmes para assistir na quarentena "),
  /*#__PURE__*/_createElementVNode("p", { class: "netflix-info" }, "Lista de Clinicarx na Netflix")
], -1)
const _hoisted_18 = {
  key: 4,
  class: "link-embed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_result_button = _resolveComponent("share-result-button")!
  const _component_agile = _resolveComponent("agile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["navigation-dot", { selected: _ctx.currentSlide == 0 }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["navigation-dot", { selected: _ctx.currentSlide == 1 }])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_agile, {
        mobileFirst: "",
        infinite: false,
        dots: false,
        navButtons: false,
        unagile: false,
        onAfterChange: _ctx.changeSlide
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["slide result-test-slide d-flex", { selected: _ctx.currentSlide == 0 }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.resultInfos.title), 1),
                _hoisted_5,
                _createElementVNode("span", null, _toDisplayString(_ctx.resultInfos.subtitle), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.resultInfos.info), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.resultInfos.imageResult,
                class: _normalizeClass(["floating-image", _ctx.resultInfos.class])
              }, null, 10, _hoisted_8)
            ]),
            _createVNode(_component_share_result_button, {
              onOpenResultCard: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-result-card')))
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["slide playlist-slide", { selected: _ctx.currentSlide == 1 }])
          }, [
            (_ctx.resultInfos.title != 'Positivo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Sua track do dia "))
              : _createCommentVNode("", true),
            (_ctx.resultInfos.title == 'Positivo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Sua dica do dia "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.resultInfos.title) + " " + _toDisplayString(_ctx.resultInfos.subtitle), 1),
            (_ctx.resultInfos.title != 'Positivo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("iframe", {
                    id: "embed-iframe",
                    style: {"border-radius":"12px"},
                    src: _ctx.resultInfos.playlistUrl,
                    width: "100%",
                    height: "80",
                    frameBorder: "0",
                    allowfullscreen: "",
                    allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  }, null, 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true),
            (_ctx.resultInfos.title == 'Positivo')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  style: {"text-decoration":"none"},
                  target: "_blank",
                  href: "https://bit.ly/vcEmQuarentena",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickNetflix()))
                }, [
                  (_ctx.resultInfos.title == 'Positivo')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("img", {
                            class: "netflix-logo",
                            src: _ctx.urlLogoNetflix,
                            alt: ""
                          }, null, 8, _hoisted_16),
                          _hoisted_17
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.resultInfos.title == 'Positivo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("p", null, "Acesse em: " + _toDisplayString(_ctx.resultInfos.playlistUrl), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_share_result_button, {
              onOpenResultCard: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open-result-card')))
            })
          ], 2)
        ]),
        _: 1
      }, 8, ["onAfterChange"])
    ])
  ]))
}